// @flow

import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import gql from 'graphql-tag';
import './Rating.less';
import {FormattedMessage} from 'react-intl';

import type {Node} from 'react';

export const fragments = {
    listing: gql`
        fragment RatingListing on Listing {
            averageRating
            reviewCount
        }
    `
};
export type ListingShape = {
    averageRating: number,
    reviewCount: number,
    starSize: string
};
export type Props = {
    listing: ListingShape
};

const Rating = ({listing: {averageRating, reviewCount, starSize}}: Props) => {
    if (!reviewCount) {
        return (
            <span className="sr-only">
                <FormattedMessage id="noReviews" defaultMessage="no reviews" />
            </span>
        );
    }

    return (
        <Fragment>
            <div className={'Rating__starRating'} aria-hidden="true">
                <StarRating rating={averageRating} size={starSize} />
            </div>
            <span className="Rating__ratingcount" aria-hidden="true">
                {`(${reviewCount})`}
            </span>
            <span className="sr-only">
                <FormattedMessage
                    id="ratingScreenReaderLabel"
                    defaultMessage="Guest Rating: {rating} out of possible 5 stars. Number of Reviews: {reviewCount}"
                    values={{
                        rating: averageRating.toFixed(2),
                        reviewCount
                    }}
                >
                    {(txt: Node): Node => txt}
                </FormattedMessage>
            </span>
        </Fragment>
    );
};

export default Rating;
